var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "cart-page page" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "page__inner container-padding cart-page__container" },
      [
        !_vm.ordering
          ? [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.cartItems.length,
                      expression: "!cartItems.length",
                    },
                  ],
                  staticClass: "cart-page__empty",
                },
                [_vm._v("Корзина пуста")]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cartItems.length,
                      expression: "cartItems.length",
                    },
                  ],
                  staticClass: "cart-page__main",
                },
                [
                  _c("CartHeaderComponent"),
                  _c(
                    "div",
                    { staticClass: "cart-page__items" },
                    _vm._l(_vm.cartItems, function (item, i) {
                      return _c("CartItemComponent", {
                        key: i,
                        attrs: { data: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]
          : [
              _c("div", { staticClass: "cart-page__main" }, [
                _c(
                  "div",
                  { staticClass: "cart-page__wrapper" },
                  [
                    _c("h6", [_vm._v("Адрес и доставка")]),
                    _c(
                      "div",
                      { staticClass: "cart-page__wrapper-col-2" },
                      [
                        _c("InputComponent", {
                          attrs: {
                            errors: _vm.form.city.errors,
                            placeholder: "Город",
                          },
                          model: {
                            value: _vm.form.city.value,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.city, "value", $$v)
                            },
                            expression: "form.city.value",
                          },
                        }),
                        _c("InputComponent", {
                          attrs: {
                            errors: _vm.form.street.errors,
                            placeholder: "Улица, дом",
                          },
                          model: {
                            value: _vm.form.street.value,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.street, "value", $$v)
                            },
                            expression: "form.street.value",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "cart-page__wrapper-col-3" },
                      [
                        _c("InputComponent", {
                          attrs: {
                            errors: _vm.form.flat.errors,
                            placeholder: "Квартира/Офис",
                          },
                          model: {
                            value: _vm.form.flat.value,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.flat, "value", $$v)
                            },
                            expression: "form.flat.value",
                          },
                        }),
                        _c("InputComponent", {
                          attrs: {
                            errors: _vm.form.entrance.errors,
                            placeholder: "Подъезд",
                          },
                          model: {
                            value: _vm.form.entrance.value,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.entrance, "value", $$v)
                            },
                            expression: "form.entrance.value",
                          },
                        }),
                        _c("InputComponent", {
                          attrs: {
                            errors: _vm.form.floor.errors,
                            placeholder: "Этаж",
                          },
                          model: {
                            value: _vm.form.floor.value,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.floor, "value", $$v)
                            },
                            expression: "form.floor.value",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("InputComponent", {
                      attrs: {
                        errors: _vm.form.comment.errors,
                        placeholder: "Комментарий (например, код от домофона)",
                      },
                      model: {
                        value: _vm.form.comment.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.comment, "value", $$v)
                        },
                        expression: "form.comment.value",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "cart-page__wrapper" },
                  [
                    _c("h6", [_vm._v("Покупатель")]),
                    _c("InputComponent", {
                      attrs: {
                        errors: _vm.form.fio.errors,
                        placeholder: "Имя Фамилия*",
                      },
                      model: {
                        value: _vm.form.fio.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.fio, "value", $$v)
                        },
                        expression: "form.fio.value",
                      },
                    }),
                    _c("InputComponent", {
                      attrs: {
                        errors: _vm.form.phone.errors,
                        mask: "+7 (###) ### ## ##",
                        placeholder: "Телефон*",
                      },
                      model: {
                        value: _vm.form.phone.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.phone, "value", $$v)
                        },
                        expression: "form.phone.value",
                      },
                    }),
                    _c("InputComponent", {
                      attrs: {
                        errors: _vm.form.email.errors,
                        placeholder: "Электронный адрес*",
                      },
                      model: {
                        value: _vm.form.email.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.form.email, "value", $$v)
                        },
                        expression: "form.email.value",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
        _c("CartAsideComponent", {
          attrs: { loading: _vm.loading, ordering: _vm.ordering },
          on: {
            "order-create": _vm.submit,
            toOrdering: ($event) => (_vm.ordering = $event),
          },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page__inner container-padding" }, [
      _c("h1", [_vm._v("Корзина")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }